import { createAction } from 'redux-actions';

export const toggleIsSaved = createAction('TOGGLE_SAVE_ANIMATION');

export const setIsInitialRender = createAction('SET_IS_INITIAL_RENDER');



// WEBPACK FOOTER //
// ./src/actions/events.js